<script>
export default dsf.component({
  name: "DsfSubTableColumn",
  inheritAttrs: false,
  mixins: [$mixins.layout],
  ctrlCaption: "子表列",
  props: {
    column: {
      type: Object,
      default() {
        return {
          label: "",
          children: []
        };
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    }
    // totalWidth: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      // realWidth: this.column.width
      tableWidth: 0,
      editable: false
    };
  },
  created() {},
  computed: {
    ownerTable() {
      let parent = this.$parent;
      while (parent.$options.name != "DsfSubTable") {
        parent = parent.$parent;
      }
      return parent;
    },
    bodyWidth() {
      return this.elTable.bodyWidth;
    },

    elTable() {
      return this.$parent;
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    clickHandler(evt) {
      let list = this.$list;
      if(!list.value?.length){
        return false;
      }
      if (!list.isDesign) {
        if (this.column.filterInfo) {
          let filterInfo = this.column.__data__.filterInfo;
          let mkey = filterInfo.field;
          let type = filterInfo.type;
          let multiple = filterInfo.multiple;
          let dataSource = filterInfo.dataSource;
          let currentFilter = filterInfo.value;
          let dialogHeight = "50vh";
          if (type) {
            dialogHeight = type == "number" || type == "ymd" || type == "ym" ? "30vh" : dialogHeight;
            this.$openDialog({
              title: "筛选过滤",
              content: "DsfColumnDataFileter",
              width: "400px",
              height: dialogHeight,
              overflow: "hidden hidden",
              params: {
                list: list,
                type: type,
                field: mkey,
                multiple: multiple === void 0 ? true : (multiple || false),
                dataSource: dataSource,
                currentFilter: currentFilter || null,
                subTableData: list.value,
              },
              btns: [
                {
                  text: "确定",
                  handler: (res) => {
                    this.setFilterValue(filterInfo, res.yes());
                  }
                },
                {
                  text: "清除过滤",
                  handler: (res) => {
                    this.setFilterValue(filterInfo, null);
                  }
                },
                {
                  text: "取消"
                }
              ],
              closed() {
                mkey = null;
                type = null;
                dataSource = null;
                currentFilter = null;
                filterInfo = null;
              }
            });
          }
        }
      }
      evt.stopPropagation();
    },
    setFilterValue(filterInfo, v) {
      this.$set(filterInfo, "value", v);
      this.$list.setFilterInfo();
    },
    getWidth(column) {
      let width = column.width;
      let totalWidth = this.ownerTable.tableWidth;
      if (totalWidth) {
        if (dsf.type(width) == "string" && width && width.endsWith("%")) {
          let w = parseFloat(width.replace("%", "")) / 100;
          let indexColumnWidth = this.ownerTable.isShowIndexColumn ? 60 : 0;
          let operateColumnWidth = this.ownerTable.isShowOperateColumn ? 130 : 0;
          let tw = totalWidth - indexColumnWidth - operateColumnWidth;
          width = parseFloat(tw) * w;
        }
      }
      return width;
    }
  },
  updated() {
    // console.log("ddd");
  },
  render(h) {
    // let table=this.ownerTable;
    return renderHeader.call(this, h, this.column, this.$vnode.data.key);
  }
});

function renderHeader(h, column, key) {
  let _this = this;
  let child = [];
  let scopedSlots = null;
  let isFilter = false;
  if (column.children && column.children.length > 0) {
    child = _.map(column.children, (c, i) => {
      return renderHeader.call(this, h, c, i);
    });
  } else {
    child = this.$slots[column.columnId];
    isFilter = column.isLast && column.isFilter && column?.filterInfo?.type;
    scopedSlots = {
      header(scope) {
        return renderElTableColumnHeader(h, _this, column, scope, isFilter);
      },
      default(scope) {
        return _this.$scopedSlots[column.columnId] && _this.$scopedSlots[column.columnId](scope);
      }
    };
  }
  let props = { ...column, type: column.type == "expand" ? "expand" : "" };
  delete props.width;
  let data = {
    key: key,
    props: { ...props },
    attrs: {
      "class-name": column.columnId,
      columnKey: column.columnId,
      ...this.$attrs,
      minWidth: props.minWidth,
      width: this.getWidth(column),
      "column-id": column.columnId
      // sortable: this.sortable
    }
  };
  if (scopedSlots) {
    data.scopedSlots = scopedSlots;
  }
  if (this.ownerTable) {
    let vnode = h("el-table-column", data, child);
    return vnode;
  }
  return null;
}
function renderLabel(h, vm, column) {
  return h("span", {
    domProps: {
      innerHTML: `${column.prefix || ""}<span>${column.label}</span>${column.suffix || ""}`
    }
  });
}
function renderFilter(h, vm, column) {
  return h(
    "span",
    {
      staticClass: "el-table__column-filter-trigger",
      on: {
        click: vm.clickHandler
      }
    },
    [
      h("i", {
        staticClass: "iconfont ",
        class: {
          "icon-filter-full": column?.filterInfo?.value,
          "icon-filter": !column?.filterInfo?.value
        }
      })
    ]
  );
}

function renderTextContent(h, vm, column) {
  return h("dsf-text-content-editable", {
    model: {
      value: column.label,
      callback(v) {
        column.label = v;
      }
    },
    on: {
      "update:editable"(v) {
        vm.editable = v;
      }
    },
    nativeOn: {
      dblclick(event) {
        this.editable = true;
      }
    },
    props: {
      editable: vm.editable
    }
  });
}

function renderElTableColumnHeader(h, vm, column, scope, isFilter) {
  let res = [];
  if (column.required) {
    res.push(
      h("i", {
        staticClass: "required",
        staticStyle: { "margin-right": "5px" }
      })
    );
  }
  let data = {
    staticClass: "ds-table-header-conent"
  };
  if (vm.ownerTable.isDesign) {
    //设计模式附加双击可编辑事件
    data.on = {
      dblclick: (event) => {
        vm.editable = true;
        vm.$nextTick(() => {
          dsf.designer.beginEditTextConent(event.currentTarget);
        });
      }
    };
  }
  
  let contentChild = [];
  if (!vm.editable) {
    //列文字
    contentChild.push(renderLabel(h, vm, column));
    //列检索
    isFilter && contentChild.push(renderFilter(h, vm, column));
  }
  res.push(h("div", data, [vm.editable ? renderTextContent(h, vm, column) : contentChild]));
  return res;
}
</script>
